import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { COMPANY_NAME } from '../config/branding';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [pending, setPending] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setPending(''); setLoading(true);
    try {
      const data = await apiFetch('/auth/register-public', { method: 'POST', body: form });
      if (data.pending) {
        setPending(data.message || 'Your account is awaiting administrator approval.');
      } else {
        login(data.user, data.token, data.audit_id);
        nav('/tickets');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, minHeight: 'calc(100vh - 70px)' }}>
      <div className="card" style={{ width: '100%', maxWidth: 420, padding: 40 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🌿</div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--status-resolved-text)' }}>Create Account</h1>
          <p style={{ color: 'var(--text-secondary)', marginTop: 4, fontSize: 14 }}>Get support from {COMPANY_NAME}</p>
        </div>

        {error && <div style={{ background: 'var(--red-50)', color: '#b91c1c', padding: '10px 14px', borderRadius: 8, marginBottom: 20, fontSize: 14 }}>{error}</div>}
        {pending && <div style={{ background: 'var(--action-bg)', color: 'var(--status-resolved-text)', border: '1px solid var(--action-hover)', padding: '12px 14px', borderRadius: 8, marginBottom: 20, fontSize: 14 }}>✓ {pending} You'll be able to sign in once approved.</div>}

        {!pending && (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Full Name</label>
            <input className="input" placeholder="Jane Smith" value={form.name}
              onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
          </div>
          <div className="form-group">
            <label className="label">Email</label>
            <input className="input" type="email" placeholder="you@example.com" value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
          </div>
          <div className="form-group">
            <label className="label">Password</label>
            <input className="input" type="password" placeholder="Min. 6 characters" value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required minLength={6} />
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={loading}>
            {loading ? <span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} /> : 'Create Account'}
          </button>
        </form>
        )}

        <div style={{ marginTop: 20, textAlign: 'center', fontSize: 14, color: 'var(--text-secondary)' }}>
          Already have an account? <Link to="/login" style={{ color: '#0d7a28', fontWeight: 500 }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}
